export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 100,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_reportBudgetNo') || '预算单号',
    field: 'reportBudgetNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_department_name') || '部门名称',
    field: 'depName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_team_name') || '团队名称',
    field: 'teamName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_budget_year') || '预算年度',
    field: 'budgetYear',
    minWidth: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.label_beginDate') || '开始日期',
    field: 'beginDate',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('INDEX.label_endDate') || '结束日期',
    field: 'endDate',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_budget_amount') || '预算总额',
    field: 'v_totBudget',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true
  },
  {
    title: that.$l('table_label_Budget_status') || '预算状态',
    field: 'v_reportBudgetStatus',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.creator') || '创建人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'createTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.create_date') || '创建时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
